<div class="d-flex align-items-center gap-1" >
    <button class="vpacs-btn-table" [disabled]="deleteFlag" id="button" 
    style="width:85px; height:30px; color:#676a6e; font-size: 11px"
        (click)="btnClickedHandler()">{{buttonName}}</button>